<template>
  <div>
    
    <template v-if="dados">

      <div class="card dashcard" v-if="( options_classes && options_classes.length ) || ( $store.state.unidade.unidade_operacaos.length > 1 )" >
        <div class="card-body">
          <div class="form-row">
            <div class="col col-12 col-md-4" v-if="$store.state.unidade.unidade_operacaos.length > 1">
              <az-input
                :edicao="!$store.state.user.id_unidade_operacao"
                type="select"
                placeholder="Todas"
                :optionsList="$util.unidades_com_tags(true, true)"
                optionsData="id_unidade_operacao"
                v-model="id_unidade_operacao"
                @input="id_recepcao = ''">
                <template v-slot:button-pre>
                  <div class="input-group-prepend">
                    <button type="button" class="btn btn-outline-primary" @click="reload()">
                      <i class="fas fa-sync-alt fa-fw"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>
            <div class="col col-12 col-md-4">
              <az-input
                icon="fas fa-concierge-bell"
                type="select"
                placeholder="Todas as Recepções..."
                :optionsList="lista_recepcoes"
                optionsData="id_recepcao"
                :edicao="id_unidade_operacao > 0"
                v-model="id_recepcao" />
            </div>
            <div class="col col-12 col-md-4">
              <az-input   
                type="select"
                placeholder="Contratos..."
                icon="fa fa-filter"
                :hli="true"
                optionsMode="json"
                :optionsList="[
                    { id: 'PJ', search: 'Contratos PJ' },
                    { id: 'PF', search: 'Contratos PF' },
                ]" 
                optionsData="id"
                v-model="tipo_contrato" />
            </div>
          </div>

          <div class="form-row">
            <div class="col col-12 col-md-4" v-if="false">
              <az-input
                sizing="sm"
                type="button-group"
                :optionsList="[
                  { id: 'L', search: 'Unidade do Lançamento' }, 
                  { id: 'C', search: 'Unidade da Conta' }, 
                ]"
                optionsData="id"
                :edicao="id_unidade_operacao > 0"
                v-model="tipo_filtro_unidade" />
            </div>
            
            <div class="col col-12" v-if="options_classes && options_classes.length">
              <a href="#" @click.prevent="( tag_selected == tag ? tag_selected = '' : tag_selected = tag ); reload();"
                v-for="(tag, itx) in options_classes" :key="itx">
                <span class="badge ml-1" :class="tag_selected == tag ? 'badge-success' : 'badge-secondary'">
                    {{ tag }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <az-break-title title="Situação Financeira Atual" />

      <div class="card-deck">

        <div class="card carde">
          <div class="card-body">

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Contas a Pagar</div>
                <a href="#" @click.prevent="abrir_lancamentos('D', 'aberto')" class="card-link">
                  <!-- $emit('abrirlanc', { mes: 'T', natureza: 'D', status: 'A', id_unidade_operacao: id_unidade_operacao }) -->
                  <span class="lead text-danger">{{ getValor (dados.situacao, 'valor', { ch_natureza: 'D' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_valor', { ch_natureza: 'D' }, false) }}</span>
              </div>
              <div class="col col-12 col-md-6">
                <div>Contas a Receber</div>
                <a href="#" @click.prevent="abrir_lancamentos('C', 'aberto')" class="card-link">
                  <!-- $emit('abrirlanc', { mes: 'T', natureza: 'C', status: 'A', id_unidade_operacao: id_unidade_operacao }) -->
                  <span class="lead text-success">{{ getValor (dados.situacao, 'valor', { ch_natureza: 'C' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_valor', { ch_natureza: 'C' }, false) }}</span>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Em atraso</div>
                <a href="#" @click.prevent="abrir_lancamentos('D', 'atraso')" class="card-link">
                  <!-- $emit('abrirlanc', { mes: 'T', natureza: 'D', status: 'T', id_unidade_operacao: id_unidade_operacao }) -->
                  <span class="lead text-danger">{{ getValor (dados.situacao, 'vencidos', { ch_natureza: 'D' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_vencidos', { ch_natureza: 'D' }, false) }}</span>
              </div>
              <div class="col col-12 col-md-6">
                <div>Em atraso</div>
                <a href="#" @click.prevent="abrir_lancamentos('C', 'atraso')" class="card-link">
                  <!-- $emit('abrirlanc', { mes: 'T', natureza: 'C', status: 'T', id_unidade_operacao: id_unidade_operacao }) -->
                  <span class="lead text-success">{{ getValor (dados.situacao, 'vencidos', { ch_natureza: 'C' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_vencidos', { ch_natureza: 'C' }, false) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-6">
                <div>Vencendo Hoje</div>
                <a href="#" @click.prevent="abrir_lancamentos('D', $util.hoje(), 'diario')" class="card-link">
                  <!-- $emit('abrirlanc', { tempo: 'diario', mes: $util.hoje(), natureza: 'D', status: 'A', id_unidade_operacao: id_unidade_operacao }) -->
                  <span class="lead text-danger">{{ getValor (dados.situacao, 'vencendo', { ch_natureza: 'D' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_vencendo', { ch_natureza: 'D' }, false) }}</span>
              </div>
              <div class="col col-12 col-md-6">
                <div>Vencendo Hoje</div>
                <a href="#" @click.prevent="abrir_lancamentos('C', $util.hoje(), 'diario')" class="card-link">
                  <span class="lead text-success">{{ getValor (dados.situacao, 'vencendo', { ch_natureza: 'C' }) }}</span>
                </a>
                <span class="badge badge-secondary ml-2">{{ getValor (dados.situacao, 'qt_vencendo', { ch_natureza: 'C' }, false) }}</span>
              </div>
            </div>

          </div>
        </div>

        <div class="card carde">
          <div class="card-body">
            <az-input
              class="mb-2"
              sizing="sm"
              type="button-group"
              :optionsList="[
                { id: 'F', search: 'Real' },
                { id: 'C', search: 'Conciliado' },
                { id: 'A', search: 'Ambos' },
              ]"
              v-model="tipoSaldo" />

            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Conta</th>
                  <th class="text-right">Saldo</th>
                  <th class="text-right" v-if="tipoSaldo == 'A'">Conciliado</th>
                  <template v-if="tem_cheque_especial && tipoSaldo != 'A'">
                    <th class="text-right">Ch Especial</th>
                    <th class="text-right">Saldo Total</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(conta, icx) in dados.contas" :key="icx">
                  <td>{{ conta.search }}
                    <span class="badge badge-light" v-if="conta.unidade_operacao && conta.unidade_operacao.st_sigla">
                      {{ conta.unidade_operacao.st_sigla }}
                    </span>
                  </td>
                  <td class="text-right" :class="( tipoSaldo == 'C' ? conta.conciliado : conta.saldo ) < 0 ? 'text-danger' : ''">
                    {{ $util.formatMoeda(tipoSaldo == 'C' ? conta.conciliado : conta.saldo) }}
                  </td>
                  <td class="text-right" :class="conta.conciliado < 0 ? 'text-danger' : ''" v-if="tipoSaldo == 'A'">
                    {{ $util.formatMoeda(conta.conciliado) }}
                  </td>
                  <template v-if="tem_cheque_especial && tipoSaldo != 'A'">
                    <td class="text-right" v-if="tem_cheque_especial">
                      {{ $util.formatMoeda(conta.dc_cheque_especial) }}
                    </td>
                    <td class="text-right" :class="( tipoSaldo == 'C' ? conta.conciliado_total : conta.saldo_total ) < 0 ? 'text-danger' : ''" v-if="tem_cheque_especial">
                      {{ $util.formatMoeda(tipoSaldo == 'C' ? conta.conciliado_total : conta.saldo_total) }}
                    </td>
                  </template>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th class="text-right" :class="saldo < 0 ? 'text-danger' : ''">
                    {{ $util.formatMoeda (saldo) }}
                  </th>
                  <th class="text-right" :class="saldo_conciliado < 0 ? 'text-danger' : ''" v-if="tipoSaldo == 'A'">
                    {{ $util.formatMoeda (saldo_conciliado) }}
                  </th>
                  <template v-if="tem_cheque_especial && tipoSaldo != 'A'">
                    <th class="text-right">
                      {{ $util.formatMoeda(chequeEspecial) }}
                    </th>
                    <th class="text-right" :class="saldo_total < 0 ? 'text-danger' : ''">
                      {{ $util.formatMoeda(saldo_total) }}
                    </th>
                  </template>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>

    </template>

    <template v-else>
      <az-empty-state v-if="!dados" />
    </template>

    <template v-if="dados_mes">

      <az-break-title title="Situação no Período" />      
      <div class="row mb-3" v-if="false">
        <div class="col col-12 col-md-6">
          <az-input
            type="month" 
            v-model="referencia" />
        </div>
      </div>

      <div class="row">
        <div class="col col-12 col-md-6">
          <az-periodo v-model="filtros" :sync="true" @sync="carregar_mes" />
        </div>
        <div class="col col-12 col-md-6" v-if="dados_mes && dados_mes.periodo">
          <div class="input-group">
            <label class="form-control">
              {{ $util.getFormatDate(dados_mes.periodo.inicio) }} a {{ $util.getFormatDate(dados_mes.periodo.fim) }}
            </label>
            <div class="input-group-append">
              <print-export printid="print-diario" :dados="lista_dados_diario" :left="true" />
            </div>
          </div>
        </div>
      </div>

      <div class="progress mt-1 mb-3">
          <div class="indeterminate" v-if="$store.state.loading"></div>
          <div class="determinate" v-else></div>
      </div>

      <div class="row">
        <div class="col col-12 col-md-6">

          <div class="card carde">
            <div class="card-body">

              <div class="row mb-3">
                <div class="col col-12 col-md-4">
                  <div>Contas a Receber</div>
                  <a href="#" @click.prevent="abrir_lancamentos('C', '', null, false, filtros)" class="card-link">
                    <!-- $emit('abrirlanc', { filtros: filtros, natureza: 'C' }) -->
                    <span class="lead text-success">{{ getValor (dados_mes.situacao, 'valor', { ch_natureza: 'C' }) }}</span>
                  </a>
                  <span class="badge badge-secondary ml-3">{{ getValor (dados_mes.situacao, 'qt_valor', { ch_natureza: 'C' }, false) }}</span>
                </div>
                <div class="col col-12 col-md-4">
                  <div>Contas a Pagar</div>
                  <a href="#" @click.prevent="abrir_lancamentos('D', '', null, false, filtros)" class="card-link">
                    <!-- $emit('abrirlanc', { filtros: filtros, natureza: 'D' }) -->
                    <span class="lead text-danger">{{ getValor (dados_mes.situacao, 'valor', { ch_natureza: 'D' }) }}</span>
                  </a>
                  <span class="badge badge-secondary ml-3">{{ getValor (dados_mes.situacao, 'qt_valor', { ch_natureza: 'D' }, false) }}</span>
                </div>
                <div class="col col-12 col-md-4">
                  <div>Saldo</div>
                  <div class="lead text-primary">{{ $util.formatMoeda ( getValor (dados_mes.situacao, 'valor', { ch_natureza: 'C' }, false) - getValor (dados_mes.situacao, 'valor', { ch_natureza: 'D' }, false) ) }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col col-12 col-md-4">
                  <div>Recebidos</div>
                  <a href="#" @click.prevent="abrir_lancamentos('C', '', null, true, filtros)" class="card-link">
                    <!-- $emit('abrirextrato', { mes: referencia, natureza: 'C' }) -->
                    <span class="lead text-success">{{ getValor (dados_mes.realizado, 'valor', { ch_natureza: 'C' }) }}</span>
                  </a>
                  <span class="badge badge-secondary ml-3">{{ getValor (dados_mes.realizado, 'qt_valor', { ch_natureza: 'C' }, false) }}</span>
                </div>
                <div class="col col-12 col-md-4">
                  <div>Pagos</div>
                  <a href="#" @click.prevent="abrir_lancamentos('D', '', null, true, filtros)" class="card-link">
                    <!-- $emit('abrirextrato', { mes: referencia, natureza: 'D' }) -->
                    <span class="lead text-danger">{{ getValor (dados_mes.realizado, 'valor', { ch_natureza: 'D' }) }}</span>
                  </a>
                  <span class="badge badge-secondary ml-3">{{ getValor (dados_mes.realizado, 'qt_valor', { ch_natureza: 'D' }, false) }}</span>
                </div>
                <div class="col col-12 col-md-4">
                  <div>Saldo</div>
                  <div class="lead text-primary">{{ $util.formatMoeda ( getValor (dados_mes.realizado, 'valor', { ch_natureza: 'C' }, false) - getValor (dados_mes.realizado, 'valor', { ch_natureza: 'D' }, false) ) }}</div>
                </div>
              </div>

            </div>
            <div class="card-footer small text-muted" v-if="id_unidade_operacao">
              Lançamentos da unidade selecionada
            </div>
          </div>
        </div>

        <div class="col col-12 col-md-6">

          <div id="print-diario">

            <cabecalho-generico titulo="Saldo do Período">
              <div>Período: {{ $util.getFormatDate(dados_mes.periodo.inicio) }} a {{ $util.getFormatDate(dados_mes.periodo.fim) }}</div>
              <div v-if="dados_mes.nome_unidade">Unidade: {{ dados_mes.nome_unidade }}</div>
            </cabecalho-generico>

            <div class="card carde">
              <div class="card-header d-print-none">
                <az-input
                  sizing="sm"
                  type="button-group"
                  :optionsList="[
                    { id: 'F', search: 'Real' },
                    { id: 'C', search: 'Conciliado' },
                    { id: 'A', search: 'Ambos' },
                  ]"
                  v-model="filtros.tipo_saldo_periodo" />
              </div>
              <table class="table bg-white mb-0">
                <thead>
                  <tr>
                    <th>Conta</th>
                    <th class="text-right" v-if="filtros.tipo_saldo_periodo != 'C'">Saldo</th>
                    <th class="text-right" v-if="filtros.tipo_saldo_periodo != 'F'">Conciliado</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Saldo Inicial -->
                  <tr>
                    <td>
                      <a href="#" @click.prevent="dados_mes.saldos_ini_expand = !dados_mes.saldos_ini_expand" class="card-link text-dark">
                        <i class="far fa-plus-square" aria-hidden="true" v-if="!dados_mes.saldos_ini_expand"></i>
                        <i class="far fa-minus-square" aria-hidden="true" v-else></i>
                      </a>
                      Saldo Inicial
                    </td>
                    <td class="text-right text-nowrap" v-if="filtros.tipo_saldo_periodo != 'C'">
                      {{ getValor(dados_mes.saldos_ini, 'saldo_r', null, true) }}
                    </td>
                    <td class="text-right text-nowrap" v-if="filtros.tipo_saldo_periodo != 'F'">
                      {{ getValor(dados_mes.saldos_ini, 'saldo_c', null, true) }}
                    </td>
                  </tr>
                  <template v-if="dados_mes.saldos_ini_expand">
                    <tr class="table-secondary" v-for="(conta, icx) in dados_mes.saldos_ini" :key="icx">
                      <td>{{ conta.search }}</td>
                      <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'C'">{{ $util.formatMoeda(conta.saldo_r) }}</td>
                      <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'F'">{{ $util.formatMoeda(conta.saldo_c) }}</td>
                    </tr>
                  </template>

                  <!-- Recebidos -->
                  <tr class="table-success">
                    <td>Recebimentos</td>
                    <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'C'">
                      {{ getValor (dados_mes.realizado_conta, 'valor', { ch_natureza: 'C' }) }}
                    </td>
                    <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'F'">
                      {{ getValor (dados_mes.realizado_conta, 'valor_conciliado', { ch_natureza: 'C' }) }}
                    </td>
                  </tr>

                  <!-- Recebidos -->
                  <tr class="table-danger">
                    <td>Pagamentos</td>
                    <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'C'">
                      {{ getValor (dados_mes.realizado_conta, 'valor', { ch_natureza: 'D' }) }}
                    </td>
                    <td class="text-right" v-if="filtros.tipo_saldo_periodo != 'F'">
                      {{ getValor (dados_mes.realizado_conta, 'valor_conciliado', { ch_natureza: 'D' }) }}
                    </td>
                  </tr>
                </tbody>

                <!-- SALDO FINAL -->
                <visao-lista-contas titulo="Saldo Final" :contas="dados_mes.saldos_fim" :tipo_saldo="filtros.tipo_saldo_periodo" />

                <!-- SALDO APLICAÇÃO -->
                <visao-lista-contas titulo="Aplicações" :contas="dados_mes.saldos_fim_aplic" :tipo_saldo="filtros.tipo_saldo_periodo" />

                <!-- EMPRÉSTIMOS -->
                <visao-lista-contas titulo="Empréstimos" :contas="dados_mes.saldos_fim_emprest" :tipo_saldo="filtros.tipo_saldo_periodo" />

                <tfoot class="small text-muted" v-if="id_unidade_operacao">
                  <tr>
                    <td colspan="3">
                      Lançamentos nas contas da unidade
                    </td>
                  </tr>
                </tfoot>
                
              </table>



              <!-- 
              <ul class="list-group" v-if="false">
                <li class="list-group-item d-flex justify-content-between">
                  <div>Saldo Inicial</div>
                  <div>
                    {{ getValor(dados_mes.saldos_ini, 'saldo', null, true) }}
                    <a href="#" @click.prevent="dados_mes.saldos_ini_expand = !dados_mes.saldos_ini_expand" class="card-link text-dark">
                      <i class="far fa-plus-square" aria-hidden="true" v-if="!dados_mes.saldos_ini_expand"></i>
                      <i class="far fa-minus-square" aria-hidden="true" v-else></i>
                    </a>
                  </div>
                </li>
                <li class="list-group-item" v-if="dados_mes.saldos_ini_expand">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="(conta, icx) in dados_mes.saldos_ini" :key="icx">
                      <div>{{ conta.search }}</div>
                      <div>{{ $util.formatMoeda(conta.saldo) }}</div>
                    </li>
                  </ul>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div>Recebimentos</div>
                  <div>
                    {{ getValor (dados_mes.realizado, 'valor', { ch_natureza: 'C' }) }}
                    <i class="fa fa-plus-circle text-success" aria-hidden="true"></i>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <div>Pagamentos</div>
                  <div>
                    {{ getValor (dados_mes.realizado, 'valor', { ch_natureza: 'D' }) }}
                    <i class="fa fa-minus-circle text-danger" aria-hidden="true"></i>
                  </div>
                </li>
                <visao-lista-contas titulo="Saldo Final" :contas="dados_mes.saldos_fim" />
                <visao-lista-contas titulo="Aplicações" :contas="dados_mes.saldos_fim_aplic" />
                <visao-lista-contas titulo="Empréstimos" :contas="dados_mes.saldos_fim_emprest" />
              </ul>
              -->
              
              <div class="card-body" v-if="false">    
                <pre>{{ dados_mes }}</pre>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col col-12 col-md-9">
          <div class="input-group">
            <input class="form-control" disabled :value="'Produção ' + ( ( dados_mes && dados_mes.periodo && dados_mes.periodo.tipo_data == 'A' ) ? ' (Data do Atendimento)' : ' (Data da Guia)' )">
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-primary" @click="carregar_mes()">
                <i class="fas fa-sync-alt"></i>
              </button>
              <print-export printid="print-producao" :dados="lista_dados_producao" :left="true" />
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-3">
          <az-input 
            type="button-group"
            :optionsList="[
              { id: 'G', search: 'Data da Guia' }, 
              { id: 'A', search: 'Data do Atend' }, 
            ]"
            v-model="filtros.tipo_data"
            @input="carregar_mes()" />
        </div>
      </div>

      <div class="row mt-1">
        <div class="col col-12">
          <az-input 
            sizing="sm"
            type="checkbox-group"
            label="Abater Desconto da Produção"
            v-model="abater_desconto_comercial" />
        </div>
      </div>

      <div class="progress mt-1 mb-1">
          <div class="indeterminate" v-if="$store.state.loading"></div>
          <div class="determinate" v-else></div>
      </div>

      <div id="print-producao">

        <cabecalho-generico titulo="Produção">
          <div>Período: {{ $util.getFormatDate(dados_mes.periodo.inicio) }} a {{ $util.getFormatDate(dados_mes.periodo.fim) }}</div>
          <div v-if="dados_mes.nome_unidade">Unidade: {{ dados_mes.nome_unidade }}</div>
        </cabecalho-generico>

        <table class="table bg-white table-sm table-hover dashcard cabecalho-fixo">
          <thead>
            <tr>
              <th>Operadora</th>
              <th class="text-right">Produzido</th>
              <th class="text-right">Faturado</th>
              <th class="text-right">Recebido</th>
              <th class="text-right">Glosado</th>
              <th class="text-right">A Receber</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(prod, ipx) in dados_mes.producao" :key="ipx">
              <td>{{ prod.descricao }}</td>
              <td class="text-right">
                <a href="#" @click.prevent="ver_guias(prod, 'TA')" class="card-link">
                  {{ $util.formatMoeda(prod.produzido) }}
                </a>
              </td>
              <td class="text-right">
                <a href="#" @click.prevent="ver_guias(prod, 'FF')" class="card-link">
                  {{ $util.formatMoeda(prod.valor) }}
                </a>
              </td>
              <td class="text-right">{{ $util.formatMoeda(prod.recebido) }}</td>
              <td class="text-right">{{ $util.formatMoeda(prod.glosado) }}</td>
              <td class="text-right">{{ $util.formatMoeda(prod.a_receber) }}</td>
            </tr>
            <template v-if="dados_mes.particular && dados_mes.particular.length">
              <tr class="table-secondary">
                <th>SUBTOTAL</th>
                <th class="text-right">{{ $util.formatMoeda(total_prod('produzido', false)) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_prod('valor', false)) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_prod('recebido', false)) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_prod('glosado', false)) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_prod('valor', false) - total_prod('recebido', false) - total_prod('glosado', false)) }}</th>
              </tr>
              <tr class="table-secondary">
                <th>PARTICULAR</th>
                <th class="text-right">Produzido</th>
                <th class="text-right">Pago</th>
                <th class="text-right">Baixado</th>
                <th class="text-right">Desconto</th>
                <th class="text-right">A Baixar</th>
              </tr>
              <tr v-for="(part, ipx) in dados_mes.particular" :key="'P' + ipx">
                <td>{{ part.st_plano }}</td>
                <td class="text-right">{{ $util.formatMoeda(part.produzido) }}</td>
                <td class="text-right">
                  <a href="#" @click.prevent="ver_pagamentos({ ...part, tipo_data: 'A' })" class="card-link">
                    {{ $util.formatMoeda(part.valor) }}
                  </a>
                </td>
                <td class="text-right">{{ $util.formatMoeda(part.recebido) }}</td>
                <td class="text-right">{{ $util.formatMoeda(part.glosado) }}</td>
                <td class="text-right">{{ $util.formatMoeda(part.valor - part.recebido) }}
                  <div v-if="part.no_financeiro && part.no_financeiro > 0" class="text-muted small" title="Já no financeiro.">
                    {{ $util.formatMoeda(part.no_financeiro) }}
                  </div>
                </td>
              </tr>
              <tr class="table-secondary">
                <th>SUBTOTAL</th>
                <th class="text-right">{{ $util.formatMoeda(total_partic('produzido')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_partic('valor')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_partic('recebido')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_partic('glosado')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_partic('valor') - total_partic('recebido')) }}</th>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr class="bg-dark text-white">
              <th>TOTAL</th>
              <th class="text-right">{{ $util.formatMoeda(total_prod('produzido')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(total_prod('valor')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(total_prod('recebido')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(total_prod('glosado')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(total_prod('valor') - total_prod('recebido') - total_prod('glosado', false)) }}</th>
            </tr>
          </tfoot>
        </table>

      </div>

      <div v-if="dados_mes && dados_mes.recebido_particular">
        <div class="form-row">
          <div class="col col-12 col-md-9">
            <div class="input-group">
              <input class="form-control" disabled value="Recebido Particular">
              <div class="input-group-append">
                <button type="button" class="btn btn-outline-primary" @click="carregar_mes()">
                  <i class="fas fa-sync-alt"></i>
                </button>
                <print-export printid="print-recebido-particular" :dados="lista_dados_recebido_particular" :left="true" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-3 d-flex flex-column">
            <az-input
              type="button-group"
              :optionsList="[
                { id: 'estado', search: 'Status' },
                { id: 'st_forma_pagamento', search: 'Forma Pg' }, 
              ]"
              optionsData="id"
              v-model="campo_agrupamento" />
          </div>
        </div>

        <div class="progress mt-1 mb-2">
          <div class="indeterminate" v-if="$store.state.loading"></div>
          <div class="determinate" v-else></div>
        </div>
      </div>

      <template v-if="dados_mes && dados_mes.recebido_particular">

        <div id="print-recebido-particular">

          <cabecalho-generico titulo="Recebido Particular">
            <div>Período: {{ $util.getFormatDate(dados_mes.periodo.inicio) }} a {{ $util.getFormatDate(dados_mes.periodo.fim) }}</div>
            <div v-if="dados_mes.nome_unidade">Unidade: {{ dados_mes.nome_unidade }}</div>
          </cabecalho-generico>

          <table class="table bg-white table-sm table-hover dashcard cabecalho-fixo">
            <thead>
              <tr>
                <th>Forma de Pagamento</th>
                <th class="text-right">Adiantamento (A)</th>
                <th class="text-right">Atendimento (B)</th>
                <th class="text-right">Total (A+B)</th>
              </tr>
            </thead>
            <tbody v-for="(items, grupo, igx) in agrupar(dados_mes.recebido_particular, campo_agrupamento)" :key="igx">
              <tr class="table-info">
                <th>{{ grupo }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(items, 'valor_adt')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(items, 'valor_atd')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(items, 'valor')) }}</th>
              </tr>
              <tr v-for="(receb, ipx) in items" :key="ipx">        
                <td>{{ campo_agrupamento == 'estado' ? receb.st_forma_pagamento : receb.estado }}</td>
                <td class="text-right">{{ $util.formatMoeda(receb.valor_adt) }}</td>
                <td class="text-right">{{ $util.formatMoeda(receb.valor_atd) }}</td>
                <td class="text-right">
                  <a href="#" @click.prevent="ver_pagamentos(receb)" class="card-link">
                    {{ $util.formatMoeda(receb.valor) }}
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-dark text-white">
                <th>TOTAL</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(dados_mes.recebido_particular, 'valor_adt')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(dados_mes.recebido_particular, 'valor_atd')) }}</th>
                <th class="text-right">{{ $util.formatMoeda(total_campo(dados_mes.recebido_particular, 'valor')) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="alert alert-secondary small">
          <div>
            <strong>Adiantado</strong> = Valores recebidos no período, provenientes de adiantamentos, pela data do adiantamento.
          </div>
          <div>
            <strong>Atendimento</strong> = Valores recebidos no período, provenientes de pagamentos realizados no ato do atendimento.
          </div>

          <div class="mt-2">A soma dos dois valores representa o valor recebido em caixa no período selecionado. </div>
        </div>
          
      </template>

      <pre v-if="false && dados_mes">{{ dados_mes.recebido_particular }}</pre>
      <pre class="alert alert-warning" v-if="false && dados">{{ dados_mes }}</pre>

    </template>

    <lancamentos-modal ref="lancs" />
    
  </div>
</template>

<script>
import * as moment from "moment";
import $ from  'jquery';
import _ from 'lodash';
import AzBreakTitle from '../../util/AzBreakTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import VisaoListaContas from './VisaoListaContas.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import LancamentosModal from './LancamentosModal.vue';

export default {
  data() {
    return {
      dados: null,
      dados_mes: null, 
      referencia: this.$util.hoje().substr(0,7),
      tipo_filtro_unidade: 'L', 
      options_classes: [], 
      tag_selected: "", 
      montando: true, 
      tipoSaldo: "F", 
      filtros: { 
        inicio: "",
        fim: "", 
        periodo: "m",
        tipo_saldo_periodo: "F", 
        tipo_data: "G",
      }, 
      id_unidade_operacao: "", 
      id_recepcao: "", 
      tipo_contrato: "", 
      abater_desconto_comercial: false, 
      campo_agrupamento: 'estado', 
    };
  },

  components: { 
    AzBreakTitle,
    AzInput,
    AzEmptyState,
    AzPeriodo, 
    VisaoListaContas,
    PrintExport, 
    CabecalhoGenerico,
    LancamentosModal,  
  },

  watch: { 
    referencia: function () { 
      this.carregar_mes ();
    }
  },

  computed: { 
    lista_recepcoes: function () { 
      if ( !this.id_unidade_operacao ) { 
        return [];
      }

      let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

      if ( unid ) { 
        return unid.recepcaos;
      } else { 
        return [];
      }
    },

    lista_dados_diario: function () { 
      return [
        { descr: 'Saldo Inicial', valor: this.getValor(this.dados_mes.saldos_ini, 'saldo', null, false) }, 
        { descr: 'Recebimentos', valor: this.getValor(this.dados_mes.realizado, 'valor', { ch_natureza: 'C' }) }, 
        { descr: 'Pagamentos', valor: this.getValor(this.dados_mes.realizado, 'valor', { ch_natureza: 'D' }) }, 
        { descr: 'Saldo Final', valor: this.getValor(this.dados_mes.saldos_fim, 'saldo', null, false) }, 
        { descr: 'Aplicações', valor: this.getValor(this.dados_mes.saldos_fim_aplic, 'saldo', null, false) }, 
        { descr: 'Empréstimos', valor: this.getValor(this.dados_mes.saldos_fim_emprest, 'saldo', null, false) }, 
      ]
    },

    lista_dados_producao: function () { 
      if ( !this.dados_mes || !this.dados_mes.producao )
        return [];

      let partic = this.dados_mes.particular.map(part => { 
          return { 
            descricao: part.st_plano, 
            produzido: this.$util.formatMoeda(part.produzido), 
            faturado_pago: this.$util.formatMoeda(part.valor), 
            recebido_baixado: this.$util.formatMoeda(part.recebido),
            glosado_desconto: this.$util.formatMoeda(part.glosado),
            a_receber_a_baixar: this.$util.formatMoeda(part.valor - part.recebido), 
          };
      });
                
      return this.dados_mes.producao.map(prod => { 
        return { 
          descricao: prod.descricao,
          produzido: this.$util.formatMoeda(prod.produzido), 
          faturado_pago: this.$util.formatMoeda(prod.valor), 
          recebido_baixado: this.$util.formatMoeda(prod.recebido),
          glosado_desconto: this.$util.formatMoeda(prod.glosado),
          a_receber_a_baixar: this.$util.formatMoeda(prod.a_receber), 
        };
      }).concat(partic);
    },

    lista_dados_recebido_particular: function () { 
      return [];
    },

    tem_cheque_especial: function () { 
      if ( !this.dados )
        return false;

      return this.dados.contas.findIndex(item => item.dc_cheque_especial) >= 0;
    },

    chequeEspecial: function () { 
      if ( !this.dados )
        return 0;

      return _.sumBy(this.dados.contas, 'dc_cheque_especial');
    },

    saldo () { 

      if ( !this.dados )
        return 0; 

      return this.dados.contas.reduce((total, item) => { 
        return total + ( this.tipoSaldo == 'C' ? item.conciliado : item.saldo );
      }, 0);
      
    },

    saldo_conciliado () { 

      if ( !this.dados )
        return 0; 

      return this.dados.contas.reduce((total, item) => { 
        return total + item.conciliado;
      }, 0);
      
    },

    saldo_total: function () { 
      return this.saldo + this.chequeEspecial;
    },

    total_recebido_particular: function () { 
      return this.dados_mes.recebido_particular.reduce((total, item) => { 
        return total + item.valor;
      }, 0);
    }

  },

  methods: {
    agrupar (lista, campo) { 
      return _.groupBy(_.orderBy(lista, campo), campo);
    },

    abrir_lancamentos(natureza, mes, tempo = null, extrato = false, filtros = null) { 
      let parms = { 
        mes: mes, 
        natureza: natureza,
        id_unidade_operacao: this.id_unidade_operacao,
        tipo_data: extrato ? 'B' : '', 
        tipo: extrato ? 'R' : 'P', 
        tempo: tempo, 
        conciliado: false, 
        origem: extrato ? 'B' : 'L',  
      };

      if ( tempo == 'diario' ) { 
        parms.status = 'A';
      }

      if ( mes == 'atraso' ) { 
        parms.tempo = 'livre';
        
        parms.filtros = { 
          inicio: '1900-01-01',
          fim: moment().subtract(1, "day").format('YYYY-MM-DD')
        };

        parms.status = 'T';
      } else if ( mes == 'aberto' ) { 
        parms.tempo = 'livre';
        
        parms.filtros = { 
          inicio: '1900-01-01',
          fim: '2050-01-01'
        };

        parms.status = 'A';
      } else { 

        parms.filtros = filtros;
      }

      this.$refs.lancs.abrir(parms);
    },

    ver_guias (contexto, status) { 
      this.$router.push({ 
        name: 'guias', 
        params: { 
          status: status,
          id_operadora: contexto.id, 
          id_unidade_operacao: this.id_unidade_operacao, 
          id_recepcao: ( this.id_unidade_operacao && this.id_recepcao ) ? this.id_recepcao : '', 
          periodo: this.filtros.periodo, 
          buscar: true, 
        }
      });
    },

    ver_pagamentos (contexto, status = "") { 
      //console.log('contexto', contexto);

      this.$router.push({ 
        name: 'financeiro', 
        params: { 
          aba: 'prestacao', 
          status: status,
          id_plano: contexto.id_plano, 
          id_forma_pagamento: contexto.id_forma_pagamento, 
          id_unidade_operacao: this.id_unidade_operacao, 
          id_recepcao: ( this.id_unidade_operacao && this.id_recepcao ) ? this.id_recepcao : '', 
          periodo: this.filtros.periodo, 
          buscar: true, 
          tipo_data: contexto.tipo_data,
          pago_para: 'G'
        }
      });
    },

    total_prod (campo, particular = true) { 
      return this.dados_mes.producao.reduce((total, carry) => total + ( carry[campo] ? parseFloat(carry[campo]) : 0 ), 0)
        + ( !particular ? 0 : this.dados_mes.particular.reduce((total, carry) => total + ( carry[campo] ? parseFloat(carry[campo]) : 0 ), 0));
    },

    total_campo (lista, campo) { 
      return lista.reduce((total, item) => { 
        let valor = parseFloat(_.get(item, campo, 0)); 
        return total + ( valor ? valor : 0 );
      }, 0);
    },

    total_partic (campo) { 
      return this.dados_mes.particular.reduce((total, carry) => total + ( carry[campo] ? parseFloat(carry[campo]) : 0 ), 0);
    },

    getValor (base, campo, filtro = null, formatado = true) { 
      let valor = base.filter (item => { 
        if ( !filtro )
          return true;

        return !_.find(filtro, (element, chave) => {
            return item[chave] != element;
          });
      })
      .reduce((total, item) => { 
        return total + parseFloat(item[campo]);
      }, 0);

      return formatado ? this.$util.formatMoeda(valor) : valor;
    },
    imprimir() {
      this.$htmlToPaper("guias", () => {
        console.log("Printing completed or was cancelled!");
      });
    },
    atestadoModal() {
      $("#modalAtestado").modal("show");
    },
    carregar_mes () { 
      this.$util.setCookie('vgf-adc', this.abater_desconto_comercial ? 'S' : 'N');

      this.$util.load(this, { 
        service: 'financeiro',
        func: 'visao',
        parms: { 
          referencia: this.referencia, 
          tag: this.tag_selected, 
          ...this.filtros,
          id_unidade_operacao: this.id_unidade_operacao,
          id_recepcao: this.id_recepcao,
          tipo_contrato: this.tipo_contrato, 
          tipo_filtro_unidade: this.tipo_filtro_unidade,
          abater_desconto_comercial: this.abater_desconto_comercial, 
        },
        loadTo: (dados) => { 
          this.dados_mes = dados;
        }
      });
    },

    reload() { 

      if ( this.montando )
        return;

      this.$util.setCookie('id_unidade_operacao', isNaN(this.id_unidade_operacao) ? '' : this.id_unidade_operacao);

      this.$util.load(this, { 
        service: 'financeiro',
        func: 'visao',
        parms: { 
          tag: this.tag_selected, 
          id_unidade_operacao: this.id_unidade_operacao,
          id_recepcao: this.id_recepcao, 
          tipo_contrato: this.tipo_contrato, 
          tipo_filtro_unidade: this.tipo_filtro_unidade
        }
      });

      this.carregar_mes();

    }
  },

  beforeMount() { 
    this.id_unidade_operacao = this.$store.state.user.id_unidade_operacao
      ? this.$store.state.user.id_unidade_operacao
      : this.$util.getCookie('id_unidade_operacao');

    this.abater_desconto_comercial = this.$util.getCookie('vgf-adc') == 'S';
  },

  mounted () { 
    this.$store.commit("setBreadcrumb", [
      { name: "Financeiro", path: "/financeiro/visao" },
      { name: "Visão Geral", path: "/financeiro/visao" }
    ]);

    this.$util.loadItem(this, { 
        service: 'contas',
        func: 'tags',
    })
    .then(res => { 
        this.options_classes = res;

        if ( this.options_classes.find(item => item == 'Geral') ) { 
          this.tag_selected = 'Geral';
        }

        this.$util.load(this, { 
          service: 'financeiro',
          func: 'visao',
          parms: { 
            tag: this.tag_selected, 
            id_unidade_operacao: this.id_unidade_operacao,
            tipo_filtro_unidade: this.tipo_filtro_unidade
          }
        });

    });

    this.carregar_mes ();

    this.$nextTick(() => { 
      this.montando = false;
    });
  }

};
</script>